export default __webpack_public_path__ + "static/media/expensify.c7b52ff7.JPG";